<template>
  <div id="login_panel" name="Login" v-if="dialogVisible">
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="488px"
      height="672px"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :z-index="5000">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- 登录 -->
        <el-tab-pane :label="$t('login')" name="login" v-if="!isSmsLogin">
          <div class="phone mB16 mT16">
            <!-- <div class="pre_phone">+86</div> -->
             <el-input v-model="phone" :placeholder="$t('placeholders.phone')" type="text" class="phone_call ime_mode_dis" @keyup.enter.native="doLogin">
             </el-input>
          </div>
          <el-input v-model="password" :placeholder="$t('placeholders.psd')" :maxlength="16" :minlength="6" type="password" @keyup.enter.native="doLogin"></el-input>
          <div class="forget_password"><span  @click="toForgetPassword">{{$t('forget')}}</span></div>
          <el-button type="primary" @click="doLogin" :disabled="!canLogin" class="btn_login mB32" round>{{$t('login')}}</el-button>
          <div class="line-text">{{$t('others')}}</div>
          <div class="mT24 container">
            <div class="wx-container cursor" @click="triggerSmsLogin">
              <div class="img-icon"><img src="../../../assets/img/login/PC-短信登录.png" alt=""></div>
              <div  class="mT8">{{$t('smsLogin')}}</div>
            </div>
            <div class="wx-container cursor" @click="toWeChatLogin">
              <div class="img-icon"><img src="../../../assets/img/login/PC-微信登录.png" alt=""></div>
              <div  class="mT8">{{$t('weChatLogin')}}</div>
            </div>
            <!-- <div class="qq-container" id="qqLoginBtn">
              <i class="blpc blpcqq1 icon"></i>
              <div  class="mT8">QQ登录</div>
            </div> -->
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('smsLogin')" v-else name="login">
          <div class="phone mB16 mT16">
            <!-- <div class="pre_phone">+86</div> -->
             <el-input v-model="phone" :placeholder="$t('placeholders.phoneOnly')" type="tel" :minlength="11"  :maxlength="11" class="phone_call ime_mode_dis" @keyup.enter.native="doLogin(true)"></el-input>
          </div>
          <!--浏览器默认账号后的框框是密码所以会自动填后面加一个不可见的框防止它填充下面的验证码-->
          <el-input style="display: none"></el-input>
          <el-input v-model="smsValidateCode" :placeholder="$t('placeholders.smsValidateCode')" :maxlength="6" :minlength="6"  @keyup.enter.native="doLogin(true)" autocomplete = 'new-password'>
            <div class="append" slot="append" :class="{active: (timeRemain == 60) && phone}">
              <span class="cursor" @click="getSmsValidateCode">{{timeRemain == 60 ? $t('sendSmsCode') : `${$t('resendSmsCode')}(${timeRemain})s`}}</span>
            </div>
          </el-input>
          <div class="forget_password tal"><span  @click="triggerSmsLogin">{{$t('acountLogin')}}</span></div>
          <el-button type="primary" @click="doLogin(true)" :disabled="!smsLoginDisabled" class="btn_login mB32" round>{{$t('login')}}</el-button>
        </el-tab-pane>
        <!-- 注册 -->
        <el-tab-pane :label="$t('register')" name="register">
          <div class="phone mB16 mT16">
            <!-- <div class="pre_phone">+86</div> -->
             <el-input v-model="phone" :placeholder="$t('placeholders.phone')"  style="ime-mode:disabled" class="phone_call ime_mode_dis" @blur="cheackLeago"></el-input>
          </div>
          <div class="phone mB16">
            <el-input v-model="inputGraphCode" :maxlength="4" :placeholder="$t('placeholders.graphCode')" class="verify_input">
            <div class="append" slot="append" >
              <div class="verify_img_box" @click="getGraphCode"><img :src="graphInfo.graphUrl" alt=""></div>
            </div>
            </el-input>
            <!-- <div class="verify_img_box" @click="getGraphCode"><img :src="graphInfo.graphUrl" alt=""></div> -->
          </div>
          <div class="phone mB16">
            <el-input v-model="smscode" :maxlength="6" :placeholder="$t('placeholders.verifCode')" class="phone_call">
             <div class="append" slot="append" :class="{active: (timeInterval == 60 && canGetVerifCode)}">
                <span class="cursor" @click="getVerifCode">{{verifTip}}</span>
              </div>
            </el-input>
            <!-- <el-button type="primary" @click="getVerifCode" :disabled="!canGetVerifCode" class="btn_input" v-text="verifTip"></el-button> -->
          </div>
          <div class="phone mB16">
             <el-input v-model="regPassword" :placeholder="$t('placeholders.psd')" :maxlength="16" :minlength="6" type="password" class="verify_input">
             </el-input>
          </div>
          <div class="phone mB32">
            <el-input v-model="regPassword1" :placeholder="$t('placeholders.rpsd')" :maxlength="16" :minlength="6" type="password" class="verify_input">
            </el-input>
          </div>
          <div class="protral_private">
            <el-checkbox v-model="agreement"><b>{{$t('readAndAgreed')}}</b></el-checkbox>
            <span @click="toPage('newprofile')">《{{$t('profile')}}》</span>、<span @click="toPage('newprivateInfo')">《{{$t('privateInfo')}}》</span>、<span @click="toPage('childrenProfile')">《{{$t('childernProfile')}}》</span><span style="color: #030A17;">{{$t('flowLogin70')}}</span><span @click="toPage('childrenPrivateInfo')">《{{$t('childrenPrivateInfo')}}》</span>
          </div>
          <el-button type="primary" @click="doRegister" :disabled="!canRegister" round class="btn_login" style="margin-bottom: 10px">{{$t('register')}}</el-button>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
    <!-- <script
      charset='utf-8'
      src='//connect.qq.com/qc_jssdk.js'
      data-appid='101913592'
      data-redirecturi='http://www.kobe.com/myproject1'>
    </script> -->
    <!-- <script>
      QC.Login({
        btnId: 'qqLoginBtn' // 插入按钮的节点id
      })
    </script> -->
  </div>
</template>

<script>
import md5 from 'js-md5'
import store from '@/store'
import i18n from '../../../i18n'                                 // 国际化
import { MessageBox } from 'element-ui'
import { pcHashHref, pcHashFullUrl } from '@/assets/js/pcJumpUrl'

export default {
  name: 'Login',
  i18n,
  data () {
    return {
      activeName: 'login',
      dialogVisible: true,
      isEmail: false,
      phone: '',
      password: '',
      inputGraphCode: '',
      smsValidateCode: '',   // 短信验证码
      graphInfo: { // 图形验证信息
        graphCode: '',
        graphCodeKey: '',
        graphUrl: ''
      },
      busy: false,
      timer: '',
      smscode: '',
      verifTip: this.$t('verifTip'),
      timeInterval: 60,
      timeRemain: 60,
      canGetVerifCode: false, // 能否获取验证码
      agreement: false,
      regPassword: '',
      regPassword1: '',
      isSmsLogin: false,  // 是否短信登录
      returnBol: true                    // 是否启动跳转返回默认启用
    }
  },

  methods: {
    //
    inputControl (e) {
      console.log(e, 'inputControl')
      e.target.readOnly = false
    },
    // 关闭弹窗
    handleClose () {
      this.dialogVisible = false
    },
    // 检测手机号或者邮箱的合法性
    cheackLeago () {
      if (this.phone.indexOf('@') > -1) {
        this.isEmail = true
        // eslint-disable-next-line
        let myReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
        if (!myReg.test(this.phone)) {
          this.$message({
            type: 'error',
            message: this.$t('errorEmail')
          })
        }
      }  else {
        this.isEmail = false
      }
    },
    // 登录
    doLogin (isSmsLogin = false) {
      let data = {
        phone: this.phone
      }
      if (isSmsLogin === true) {
        if (this.smsLoginDisabled === false) return
        data.smsCode = this.smsValidateCode
      } else {
        data.password = md5(this.password)
      }
      let hash = window.location.hash
      this.$api.post('USER_LOGON', data, (res) => {
        // alert('res:', res)
        store.commit('set_isLogin', true)
        this.$utils.cache('userData', JSON.stringify(res.data))
        this.returnBol = false
        this.dialogVisible = false
        // 重新登录时,清除用户的sessionStorage
        if (hash === '#/recoverPassword') {
          window.location.href = pcHashFullUrl('/')
        }
        // 首页
        if (hash === '#/') {
          this.$utils.cache('showRemind', JSON.stringify(true))
        } else {
          this.$utils.cache('showRemind', null)
        }
        sessionStorage.clear()
        // 须在 clear 之后、reload 之前写入；刷新后由 App 消费并弹窗
        const { markBloomSurveyPending } = require('../../BloomSurveyDialog/pending')
        markBloomSurveyPending(res.data)
        window.location.reload()
      })
    },
    toWeChatLogin () {
      // WECHAT_LOGIN
      this.$api.post('WECHAT_LOGIN', {}, (res) => {
        window.location.href = res.data
      })
    },
    getSmsValidateCode () {
      if (!this.getCodeDisabled) {
        return
      }
      if (this.busy === true) return
      if (this.timeRemain < 60) return
      let data = {
        'phone': this.phone,
        business: 3
      }
      this.busy = true
      this.$api.post('GET_SMS_VALIDATE', data, (res) => {
        // this.close()
        this.busy = false
        if (res.code === 0) {
          MessageBox.alert(this.$t('sendAlready') + this.phone)
          this.timeRemain = 59
          this.timer = setInterval(() => {
            if (this.timeRemain > 1) {
              this.timeRemain--
            } else {
              clearInterval(this.timer)
              this.timeRemain = 60
            }
          }, 1000)
        } else {
          this.timeRemain = 60
        }
      }, () => {
        this.busy = false
      })
    },
    // 短信登录
    triggerSmsLogin () {
      this.isSmsLogin = !this.isSmsLogin
    },
    handleClick () {
    },
    // 获取图形验证码
    getGraphCode () {
      this.$api.post('USER_GRAPHCODE', '', (res) => {
        this.graphInfo = {...res.data}
        this.inputGraphCode = ''
      }, () => {
      })
    },
    // 获取验证码（手机/邮箱）
    getVerifCode () {
      this.cheackLeago()
      if (this.timeInterval < 60  || !this.canGetVerifCode) return
      this.verifTip = `${this.timeInterval}${this.$t('toReGet')}`
      this.canGetVerifCode = false
      let data = {
        'business': 1,
        'graphCodeKey': this.graphInfo.graphCodeKey,
        'graphcode': this.inputGraphCode,
        'phone': this.phone
      }
      this.$api.post('USER_GETSMSCODE', data, (res) => {
        if (res.code === 0) {
          let timer = setInterval(() => {
            if (this.timeInterval > 1) {
              this.timeInterval--
              this.verifTip = `${this.timeInterval}${this.$t('toReGet')}`
            } else {
              clearInterval(timer)
              this.timeInterval = 60
              this.canGetVerifCode = true
              this.verifTip = this.$t('verifTip')
            }
          }, 1000)
          let message = (this.isEmail === true) ? this.$t('checkEmailValidateCode') : this.$t('checkSmsValidateCode')
          MessageBox.alert(message)
        }
      }, () => {
        this.timeInterval = 60
        this.canGetVerifCode = true
        this.verifTip = this.$t('verifTip')
        this.getGraphCode()
      })
    },
    // 验证空值
    validate (...params) {
      let temp = true
      params.forEach(element => {
        if (!element) {
          temp = false
        }
      })
      return temp
    },
    // 注册
    doRegister () {
      if (!this.validate(this.regPassword, this.phone, this.smscode)) return
      if (!this.agreement) return
      if (this.regPassword !== this.regPassword1) {
        this.$message.error('两次输入的密码不一致！')
        return
      }
      if (this.regPassword.length < 6 || this.regPassword.length > 16) {
        this.$message.error('请输入6-16位密码！')
        return
      }
      let data = {
        'password': md5(this.regPassword),
        'phone': this.phone,
        'smscode': this.smscode
      }
      this.$api.post('USER_REGISTER', data, (res) => {
        // this.close()
        this.$message({
          message: this.$t('registerSucceed'),
          type: 'success'
        })
        this.activeName = 'login'
        this.isSmsLogin = false
      }, () => {
        this.getGraphCode()
      })
    },
    // 跳转忘记密码
    toForgetPassword () {
      console.warn(`${window.location.host}${pcHashHref('/recoverPassword')}`)
      window.location.href = pcHashHref('/recoverPassword')
      this.handleClose()
    },
    // 新的跳转
    toPage (url) {
      window.open(pcHashHref('/' + String(url).replace(/^\//, '')))
    },
    setLang () {
      this.$i18n.locale = this.$utils.cache('bloom:lang') === 'en' ? 'en' : 'zh'
    }
  },
  mounted () {
    this.getGraphCode()
    this.setLang()
  },
  computed: {
    meta () {
      return this.$router && this.$router.history.current.meta
    },
    getCodeDisabled () {
      return Boolean(this.phone && this.phone.length)
    },
    smsLoginDisabled () {
      return Boolean((this.phone && this.phone.length && this.phone.length === 11) && (this.smsValidateCode && this.smsValidateCode.length === 6))
    },
    canRegister () {
      return this.validate(this.regPassword, this.phone, this.smscode) && this.agreement
    },
    canLogin () {
      return this.validate(this.phone, this.password)
    }
  },
  watch: {
    // 取消登录的处理
    dialogVisible () {
      if (this.meta.goBack && this.returnBol) {          // 在有goBack属性同事满足点击的不是确定按钮
        let url = window.location.href.split('/#/')[0]   // 获取前缀
        if (this.meta.goBack === '/taskList') {          // 是任务列表时的特殊处理
          window.location.href = `${url}/#${this.meta.goBack}/${this.$utils.cache('contestId')}`
        } else {
          window.location.href = `${url}/#${this.meta.goBack}`
        }
      }
    },
    phone (val) {
      this.canGetVerifCode = this.validate(this.phone, this.inputGraphCode)
    },
    inputGraphCode (val) {
      this.canGetVerifCode = this.validate(this.phone, this.inputGraphCode)
    }
  }
}
</script>

<style lang="less" scoped>
#login_panel {
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus
  {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
  }
  /deep/.el-checkbox__inner{
    //background-color: #296BFF;
    border-color: #296BFF;
  }
  /deep/.el-checkbox__label{
    //color: #296BFF;
    color: #030A17;
  }
  /deep/ .is-checked {
    .el-checkbox__inner{
      border-color: #296BFF;
      background-color: #296BFF;
    }
  }
  .ime_mode_dis {
    ime-mode:disabled
  }
  /deep/.el-dialog__body {
    padding: 0 40px;
  }
  /deep/.el-dialog__header {
    border-radius: 16px 16px 0 0;
  }
  /deep/.el-dialog {
    border-radius: 16px;
  }
  /deep/.el-tabs__item {
    font-size: 18px;
    color: #8D8D8D;
    text-align: center;
    min-width: 80px;
    width: fit-content;
    height: 60px;
    line-height: 60px;
    font-weight: 600;
    &.is-active {
      color: #333;
    }
  }
  /deep/.el-tabs__active-bar {
    background-color: #296BFF;
    height: 3px;
    border-radius: 3px;
    width: 60px !important;
  }
  .error_tip {
    height: 40px;
    width: 458px;
    line-height: 40px;
    border: 1px solid #FFA39E;
    background: #FFF1F0;
    border-radius: 4px;
    .error_icon {
      color: red;
      font-size: 16px;
      margin: 16px;
    }
  }
  .mB32 {
    margin-bottom: 32px;
  }
  .phone {
    .pre_phone {
      display: inline-block;
      margin: 25px 25px 25px 0;
      width: 74px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
    }
    .phone_call {
      // width: 354px;
      height: 48px;
      // margin: 25px 0;
    }
  }
  .input_item {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 24px;
    position: relative;
    /deep/ input &.el-input__inner {
      border-radius: 48px;
      background: #F6F9FC;
    }
    .verify_input {
      width: 282px;
      margin-right: 24px;
    }
    .btn_input {
      width: 132px;
    }
    .w316 {
      width: 300px;
    }
    .w370 {
      width: 474px !important;
      /deep/.el-input__inner {
        width: 460px;
      }
    }
  }
  .protral_private {
    margin-bottom: 28px;
    b {
      display: inline-block;
      // margin-right: -36px;
      font-size: 14px;
    }
    span {
      color:  #296BFF;
      cursor: pointer;
    }
  }
  /deep/ .el-input-group__append {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 88px;
    border: none;
    .append {
      color: #D4D6DB;
      font-size: 14px;
      &.active {
        color: #296bff;
      }
    }
    .verify_img_box {
      height: 27px;
      width: 80px;
      border: 1px solid #DCDFE6;
      box-sizing: border-box;
      cursor: pointer;
      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  /deep/.el-input__inner {
    background: #F6F9FC;
    border-radius: 48px;
    border: none;
    height: 48px !important;
    padding: 0 24px;
    box-sizing: border-box;
    &::placeholder {
      font-size: 14px;
      color: #D4D6DB;
    }
    &:focus {
      border: 1px solid#296BFF;
    }
    // outline: 1px solid #296BFF;

  }
  .forget_password {
    font-size: 12px;
    text-align: right;
    &.tal {
      text-align: left;
    }
    margin-top: 10px;
    // font-weight: 600;
    margin-bottom: 40px;
    color: #296BFF;
    span {
      cursor: pointer;
      &:hover {
        color: #409EFF;
      }
    }
  }
  .btn_login {
    width: 100%;
    // margin-bottom: 40px;
    font-size: 16px;
    height: 48px;
    background: #296bff;
    border-radius: 48px;
    &.is-disabled {
      opacity: .5;
    }
  }
  .line-text {
    text-align: center;
    // margin-top: 10px;
    // margin-bottom: 50px;
    position: relative;
    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 35%;
      height: 1px;
      background:  #F1F1F2;
      top: 10px;
    }
    &::after {
      right: 0;
    }
    &::before {
      left: 0;
    }
  }
  .container{
    display: flex;
    justify-content: center;
  }
  .qq-container, .wx-container {
    text-align: center;
    font-size: 12px;
    color: #9499A4;
    padding: 0 20px;

    .img-icon {
      height: 48px;
      width: 48px;
      margin: 0 auto;
      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .qq-container{
    .icon:hover{
      color: #4caaf4;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/plugin/login-register/src/main.vue